import { render, staticRenderFns } from "./ExitIcon.vue?vue&type=template&id=5a64a277&scoped=true&"
var script = {}
import style0 from "./ExitIcon.vue?vue&type=style&index=0&id=5a64a277&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a64a277",
  null
  
)

export default component.exports